import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, TextField } from 'src/components';
import MapContainer from 'src/components/Map';
import Loader from 'src/components/loader';
import { fetchDetails } from 'src/redux/action/details.action';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import * as Yup from 'yup';

interface IProps {
  detailsData?: any;
  loading?: boolean;
}

const FORM_VALIDATION = Yup.object().shape({
  radius: Yup.string().required('Radius is required'),
  deliveryCharge: Yup.string().required('Delivery Charge is required'),
});

const DeliveryZone: React.FC<IProps> = ({ detailsData, loading }) => {
  const dispatch = useDispatch();
  const [latitude, setLatitude] = useState<any>(
    detailsData?.address?.coordinates?.latitude
  );
  const [longitude, setLongitude] = useState<any>(
    detailsData?.address?.coordinates?.longitude
  );
  const [mapRadius, setMapRadius] = useState<any>(detailsData?.radius);
  const initValues = {
    radius: detailsData ? detailsData?.radius : '',
    deliveryCharge: detailsData ? detailsData?.deliveryCharge : '',
  };
  const handleSubmit = async (values: any, { resetForm }: any) => {
    const payload = {
      ...values,
    };
    setMapRadius(values?.radius);
    try {
      await Service.post('/settings/update', payload);
      toastAlert('success', `Delivery zone is successfully updated`);
      dispatch(fetchDetails() as any);
      // resetForm();
    } catch (err: any) {
      toastAlert('error', err?.response?.data?.message);
    }
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Formik
          initialValues={initValues}
          validateOnMount
          onSubmit={handleSubmit}
          validationSchema={FORM_VALIDATION}
        >
          {({ isSubmitting, isValid, setFieldValue }) => (
            <Form>
              <div className="relative"></div>
              <TextField label={'Radius (In km).'} name="radius" />
              <MapContainer
                showMarker={false}
                radius={mapRadius * 1000}
                address={detailsData}
                latitude={latitude}
                setLatitude={setLatitude}
                longitude={longitude}
                setLongitude={setLongitude}
              />
              <TextField
                label="Delivery Charge (Rs)"
                name="deliveryCharge"
                type="text"
              />
              <div className="flex items-center justify-end my-2">
                <Button
                  text="save details"
                  variant="primary"
                  type="submit"
                  isSubmitting={isSubmitting}
                  isValid={isValid}
                />
              </div>
            </Form>
          )}
        </Formik>
      )}
    </>
  );
};

export default React.memo(DeliveryZone);
